import { YAxisOptions } from "highcharts";

import { ParametersUnit } from "@/lib/api";

export const getYAxisPerUnit = (unit: ParametersUnit): YAxisOptions[] => {
  if (unit.code === "degree_celsius") {
    return [{ softMin: 0, softMax: 10, title: { text: unit.symbol } }];
  }

  // Rain intensity and rain sum keep a 0-1 range even when every value is 0, so the
  // axis does not collapse to a single tick and stays readable across locations.
  if (unit.code === "millimeter_per_hour" || unit.code === "millimeter") {
    return [{ min: 0, softMax: 1, title: { text: unit.symbol } }];
  }

  if (unit.code === "percent") {
    return [{ min: 0, max: 100, title: { text: unit.symbol } }];
  }

  if (unit.code === "okta") {
    return [{ min: 0, max: 9, tickInterval: 1, title: { text: unit.symbol } }];
  }
  if (unit.code === "hectopascal") {
    return [
      {
        softMin: 950,
        softMax: 1090,
        tickPixelInterval: 50,
        title: { text: unit.symbol },
      },
    ];
  }

  if (unit.code === "degree") {
    return [
      {
        min: 0,
        max: 360,
        tickInterval: 90,
        labels: {
          formatter: (e) => {
            switch (e.value) {
              case 90:
                return `${e.value}°`;
              case 180:
                return `${e.value}°`;
              case 270:
                return `${e.value}°`;
              case 0:
              case 360:
                return `${e.value}°`;
              default:
                return e.text ?? e.value.toString();
            }
          },
        },
        title: {
          text: "",
        },
      },
      {
        linkedTo: 0,
        opposite: true,
        title: undefined,
        labels: {
          formatter: (e) => {
            switch (e.value) {
              case 90:
                return "E";
              case 180:
                return "S";
              case 270:
                return "W";
              case 0:
              case 360:
                return "N";
              default:
                return e.text ?? e.value.toString();
            }
          },
        },
      },
    ];
  }

  if (
    [
      "foot",
      "meter",
      "second",
      "minute",
      "meter_per_second",
      "knot",
      "joule_per_kilogram",
      "joule_per_square_centimeter",
      "watt_per_square_meter",
      "cd_per_square_meter",
      "kilogram_per_square_meter",
      "square_meter_per_second",
      "square_meter_per_square_second",
    ].includes(unit.code)
  ) {
    return [{ softMin: 0, title: { text: unit.symbol } }];
  }

  return [];
};
